/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isNone, isEmpty } from '@ember/utils';
import { ActionType } from 'cio/models/action';
import COLOR_LABELS from 'cio/utils/color-labels';
import { default as actionItemInfo } from 'cio/utils/action-info';
import { DropdownMessage } from 'cio/utils/conditions/action-grouping';

interface CioDeliveryFilterItemArgs {
  item: DropdownMessage;
  labelProperty: string;
}

export default class CioDeliveryFilterItem extends Component<CioDeliveryFilterItemArgs> {
  get label() {
    return this.args.item[this.args.labelProperty as keyof DropdownMessage];
  }

  get actionInfo() {
    return actionItemInfo(`${this.args.item.type}_action` as ActionType);
  }

  get variationLabel() {
    let { variation } = this.args.item;

    if (isNone(variation)) {
      return;
    }

    return COLOR_LABELS[variation - 1];
  }

  get languageLabel() {
    let { language } = this.args.item;

    if (isNone(language)) {
      return;
    }

    return isEmpty(language) ? 'Default' : language;
  }
}
